import type { User } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FormSection } from '../../components/forms/FormSection';
import { FormStack } from '../../components/forms/FormStack';
import { useUserParticipantsFilterQuery } from '../../graphql/hooks/useUserQuery';
import { useUserParticipantsFilter } from '../../hooks/useUserParticipantsFilter';
import { UserParticipantsFilterControls } from './UserParticipantFilterControls';
import { UserParticipantsTable } from './UserParticipantsTable';

interface Props {
  user: User;
}

export const UserParticipants = (props: Props) => {
  const { user } = props;

  const filter = useUserParticipantsFilter({ user });
  const { isLoading, participants, error, pagination, refetch } =
    useUserParticipantsFilterQuery(filter);

  return (
    <FormStack maxW='8xl'>
      <FormSection
        heading='Participants'
        description="You can manage a user's access to participants here."
      >
        <ChakraV3.Separator />

        <ChakraV3.Stack gap={6} w='full'>
          <UserParticipantsFilterControls filter={filter} />

          <UserParticipantsTable
            user={user}
            participants={participants}
            isLoading={isLoading}
            error={error}
            refetch={refetch}
            pagination={pagination}
          />
        </ChakraV3.Stack>
      </FormSection>
    </FormStack>
  );
};
